import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { AnalyticsEvent, trackEvent } from "@/services/analytics/amplitude"
import { Radar } from "lucide-react"
import { useState } from "react"

/**
 * Substance Radar teaser. The CTA registers interest: one Amplitude event
 * (the audience Ferdi wires the launch notification to) plus a thank-you
 * dialog. No backend persistence; the CTA is disabled after the first click
 * in this session to avoid duplicate events.
 */
export function RadarBanner() {
  const { translate } = useTranslation()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [registered, setRegistered] = useState(false)

  const onNotify = () => {
    trackEvent(AnalyticsEvent.MC_HOME_RADAR_NOTIFY_CLICKED)
    setRegistered(true)
    setDialogOpen(true)
  }

  return (
    <div className="relative mt-6 flex items-center gap-4 rounded-xl border border-dashed border-grey4 px-5 py-4">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center text-grey5">
        <Radar size={30} strokeWidth={1.25} />
      </span>
      <div>
        <div className="flex items-center gap-2.5 text-sm font-semibold text-white">
          {translate("MC_HOME_RADAR_TITLE")}
          <span className="font-mono rounded-full border border-grey4 px-2 py-1 text-[9.5px] uppercase tracking-[0.12em] text-grey5">
            {translate("MC_HOME_RADAR_PILL")}
          </span>
        </div>
        <div className="mt-1 text-xs leading-relaxed text-grey5">
          {translate("MC_HOME_RADAR_DESC")}
        </div>
      </div>
      <div className="ml-auto shrink-0">
        <Button variant="outline" disabled={registered} onClick={onNotify}>
          {translate("MC_HOME_RADAR_CTA")}
        </Button>
      </div>

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{translate("MC_HOME_RADAR_DIALOG_TITLE")}</DialogTitle>
            <DialogDescription>
              {translate("MC_HOME_RADAR_DIALOG_BODY")}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button onClick={() => setDialogOpen(false)}>
              {translate("MC_HOME_RADAR_DIALOG_CLOSE")}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  )
}
